import script from "./SettingsItemObject.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsItemObject.vue?vue&type=script&setup=true&lang=js"

import "./SettingsItemObject.vue?vue&type=style&index=0&id=772cdd90&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-772cdd90"]])

export default __exports__